import { useContext } from 'react';
import ModuleContext, { ModuleContextType } from './ModuleContext';

export default function useModuleContext(): ModuleContextType {
    const ctx = useContext(ModuleContext) as ModuleContextType;
    if (ctx === null) throw new Error('No MethodContext provided');
    return ctx;
}
